(function($) {
    // 動態插入 style
    const styleContent = `
    #marquee-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      background: white;
      color: black;
      font-size: 16px;
      line-height: 40px;
      overflow: hidden;
      z-index: 9999;
      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      transition: top 0.3s ease;
    }
    .marquee-text {
      white-space: nowrap;
      display: inline-block;
      position: absolute;
    }
  `;
    const styleEl = document.createElement('style');
    styleEl.textContent = styleContent;
    document.head.appendChild(styleEl);

    let marqueeTimer = null;
    let marqueeIndex = 0;
    let $container = null;
    let $text = null;
    let marqueeMessages = [];
    let isMarqueeRunning = false;

    function startMarquee(messages, {
        pixelsPerSecond = 100,
        startIndex = 0
    } = {}) {
        if (isMarqueeRunning) {
            marqueeMessages = messages;
            return;
        }

        isMarqueeRunning = true;
        marqueeMessages = messages;
        // marqueeIndex = startIndex % messages.length;

        $container = $('<div id="marquee-container"></div>');
        $text = $('<span class="marquee-text"></span>');
        $container.append($text);
        $('body').append($container);

        const adminBar = document.getElementById('wpadminbar');
        if (adminBar) {
            const barHeight = adminBar.offsetHeight;
            $container.css('top', barHeight + 'px');
        }

        function showNext() {
            if (!marqueeMessages.length || marqueeIndex >= marqueeMessages.length) {
                isMarqueeRunning = false;
                stopMarquee()
                return;
            }

            const msg = marqueeMessages[marqueeIndex];
            $text.text(msg);

            const textWidth = $text.outerWidth();
            const containerWidth = $container.width();
            const distance = textWidth + containerWidth;
            const duration = distance / pixelsPerSecond * 1000;

            $text.css({
                left: containerWidth + 'px',
                transform: 'none'
            });

            $text.stop().animate({
                left: -textWidth + 'px'
            }, {
                duration: duration,
                easing: 'linear',
                complete: function () {
                    marqueeIndex++;
                    marqueeTimer = setTimeout(showNext, 500);
                }
            });
        }

        showNext();
    }

    function stopMarquee() {
        if ($text) $text.stop(true);
        if (marqueeTimer) clearTimeout(marqueeTimer);
        if ($container) $container.remove();
        $container = null;
        $text = null;
        isMarqueeRunning = false;
    }


    window.startMarquee = startMarquee
    window.stopMarquee = stopMarquee
})(jQuery)